<template>
  <li>
    <a role="menuitem" target="_self" class="dropdown-item" @click="openModalColumns">
      <span>Column Setting</span>
    </a>
    <b-modal :no-close-on-backdrop="true" @hidden="resetModal" id="modal-Columns" :title="titleModal" hide-footer :centered="true" ref="modal-Columns">
      <div v-if="resizable" class="columnsShow">
        <ul>
          <template v-for="(item, index) in newData">
            <li v-if="index != 0 && item.isActive == 1">
              <gofix-form-input :label="item.label" v-model="item.width"></gofix-form-input>
            </li>
          </template>
        </ul>
      </div>

      <div v-if="!resizable" class="columnsShow">
        <ul>
          <draggable v-model="show" >
            <template v-for="(item, index) in show">
              <li v-if="index != 0 && item.isActive == 1">
                <gofix-button :label="item.label" @click="changeActiveColumnShow(item)">
                  <template slot="gofix:button:beforeLabel"><span class="closeIcon"></span></template>
                </gofix-button>
              </li>
            </template>
          </draggable>
        </ul>
      </div>
      <div v-if="!resizable" class="columnsHide">
        <ul>
          <draggable v-model="hide">
            <template v-for="(item,index) in hide">
              <li v-if="item.isActive == 0">
                <gofix-button :label="item.label" @click="changeActiveColumnHide(item)" outline>
                  <template slot="gofix:button:beforeLabel"><span class="closeIcon"></span></template>
                </gofix-button>
              </li>
            </template>
          </draggable>
        </ul>
      </div>

      <b-button-group class="d-block text-right pr-3">
        <gofix-button label="EDIT COLUMN WIDTH" @click="editColumnWeight" noBorder dark></gofix-button>
        <gofix-button :label="resizable ? 'APPLY' : 'SUBMIT'" @click="applyColumns" noBorder></gofix-button>
      </b-button-group>
    </b-modal>
  </li>
</template>
<script>
import draggable from 'vuedraggable';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'column-setting',
  components: {
    draggable
  },
  props: ["nameTable","value"],
  data () {
    return {
      titleModal: "Column Setting",
      resizable: false,
      show: [],
      hide: [],
      columnActive: this.value
    }
  },
  created(){
    if(this.UserLogin && this.UserLogin.id){
      this.getColumnSetting();
    }
  },
  computed: {
    ...mapGetters({
      UserLogin: "AuthController/user",
    }),
    newData: function() {
      return this.show.filter((val,index) => {
        if(val.thStyle){
          val.width = val.thStyle.replace( /px|^\D+/g, '');
        }else{
          val.width = 100;
        }
        return true;
      })
    }

  },
  watch: {
    UserLogin: async function(val, old) {
      if(val && val.id) {
        this.getColumnSetting();
      }
    },
    "columnActive.show": function(val){
      this.$emit('input', this.columnActive)
    }
  },
  methods: {
    getColumnSetting(){
      this.$store.dispatch('AuthController/getColumnSettingsTableUser', { user_id: this.UserLogin.id, table_name: this.nameTable }).then(response => {
        if(response.data.data.hasOwnProperty('code') && response.data.data.code == 404){
          this.show = this.columnActive.fields;
          this.columnActive.show = this.columnActive.fields;
          return;
        }

        if(response.data.data.hasOwnProperty('id')) {
          this.columnActive = {
            fields: this.columnActive.fields,
            show: response.data.data.settings.show,
            hide: response.data.data.settings.hide,
          }
          this.show = response.data.data.settings.show;
          this.hide = response.data.data.settings.hide;
        }
      }).catch(error =>{
        /*if(error.response.status == 404){
          this.show = this.columnActive.fields;
          this.columnActive.show = this.columnActive.fields;
        }*/
      })
    },
    openModalColumns() {
      this.$refs['modal-Columns'].show()
    },
    closeModalColumns() {
      this.$refs['modal-Columns'].hide()
    },
    applyColumns() {
      if(this.resizable){
        this.newData.forEach((item, index) => {
          if(item.width == "0" || !item.width){
            item.width = 100;
          }
          this.columnActive.show[index].thStyle = "width: " + item.width + "px";
        })
      }else{
        this.columnActive.show = this.show
        this.columnActive.hide = this.hide
      }
      this.$store.dispatch('AuthController/updateColumnSettingsUser', { user_id: this.UserLogin.id, table_name: this.nameTable, settings: JSON.stringify(this.columnActive) })
      .then(response => {
        this.columnActive = {
          fields: this.columnActive.fields,
          show: response.data.data.settings.show,
          hide: response.data.data.settings.hide,
        }
        this.show = response.data.data.settings.show;
        this.hide = response.data.data.settings.hide;

        this.$refs['modal-Columns'].hide();
      })
      .catch(err => { this.$refs['modal-Columns'].hide(); })
    },
    changeActiveColumnHide(item) {
      var selectedItem = Object.assign({}, item)
      selectedItem.isActive = 1
      this.show.push(selectedItem);
      this.hide = this.hide.filter(filter => filter.key != item.key)
    },
    changeActiveColumnShow(item) {
      var selectedItem = Object.assign({}, item)
      selectedItem.isActive = 0
      this.hide.push(selectedItem);
      this.show = this.show.filter(filter => filter.key != item.key)
    },
    resetModal(){
      // fix bug: when close, apply modal and reopen it -> dont drag and drop elements in list
      // re-assign this.show and this.hide
      this.show = [].concat(this.columnActive.show)
      this.hide = [].concat(this.columnActive.hide)
      this.resizable = false;
    },
    editColumnWeight(){
      this.titleModal = "Column Width (px)";
      this.resizable = true;
    }
  }
}
</script>
